export enum CasperNetworkName {
  Mainnet = 'casper',
  Testnet = 'casper-test',
  Integration = 'integration-test',
  DevNet = 'dev-net'
}

export enum AuctionManagerEntryPoint {
  delegate = 'delegate',
  undelegate = 'undelegate',
  redelegate = 'redelegate',
  addBid = 'add_bid',
  withdrawBid = 'withdraw_bid',
  activateBid = 'activate_bid'
}

export enum NFTTokenStandard {
  CEP47 = 'CEP47',
  CEP78 = 'CEP78',
  CEP95 = 'CEP95'
}
